import { FC, memo, useRef } from 'react'
import { useFormContext } from 'react-hook-form'

import { ErrorPanel, errorsFromReactHookForm } from 'ui/components'
import { ButtonGroup } from 'ui/components/ButtonGroup'
import { Button } from 'ui/components/Buttons'
import { IconName } from 'ui/components/Icon'
import { SarEdit } from '~bank-bsa-reporting/types'

import { FooterProps } from './FooterProps'

import * as SC from './styles'

export const Footer: FC<FooterProps> = memo((props) => {
  const { onDelete, onCancel, onSubmit, isSubmitting, isSarEditForm } = props

  const ref = useRef<HTMLButtonElement | null>(null)
  const { formState } = useFormContext<SarEdit>()

  return (
    <SC.Box>
      {isSarEditForm && (
        <SC.DeleteButton icon={IconName.CAN} face="negative" data-qa="Delete Page" onClick={onDelete}>
          Delete Page
        </SC.DeleteButton>
      )}
      <ButtonGroup margin="small">
        <Button face="secondary" disabled={isSubmitting} data-qa="Cancel" onClick={onCancel}>
          Cancel
        </Button>
        <Button ref={ref} loading={isSubmitting} face="primary" data-qa="Save" onClick={onSubmit}>
          Save
        </Button>
      </ButtonGroup>

      <ErrorPanel submitButtonRef={ref} errors={errorsFromReactHookForm(formState.errors)} />
    </SC.Box>
  )
})
